module.exports = __webpack_public_path__ + "static/media/coingecko.3e6be692.svg";